import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type CampaignProducts2BRequest } from '../types/apiRequest'
import { type CampaignProducts2BResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest } = createRequestHelper<
  FortuneApis['get']['campaignProductsToB'],
  CampaignProducts2BResponse,
  CampaignProducts2BRequest
>({
  client: 'fortune',
  key: (params) => {
    const { code, ...restParams } = params || {}
    if (params?.code === undefined || params?.project_code === undefined) {
      return undefined
    }
    return `/campaigns/${code}/b/products?${queryStringify(restParams, {
      skipNull: true,
    })}`
  },
  isImmutable: true,
})

export const useApiCampaignProductsToB = useRequest
